import React from "react";
import heroImage from "../../images/about-hero.jpg";

const Hero = ({ title }) => {
  return (
    <section className="relative bg-slate-900 mb-10 polygon-section">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{ backgroundImage: `url(${heroImage})` }}
      ></div>
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-32 md:pt-40 md:pb-40">
          <div className="max-w-fit mx-auto text-center pb-16">
            <h1 className="h1 font-playfair-display text-slate-100">{title}</h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
